import { AlertTriangle, RefreshCw, X } from 'lucide-react'
import { storageHealth } from '@/services/storage-health'
import { useStorageHealth } from '@/services/storage-health/useStorageHealth'

export default function StorageHealthBanner() {
  const snapshot = useStorageHealth()
  if (snapshot.status === 'ok' || !snapshot.message) return null

  const isError = snapshot.status === 'error'
  const isConflict = snapshot.kind === 'revision-conflict'
  return (
    <div
      role="alert"
      className={`relative z-50 flex w-full flex-wrap items-center gap-x-3 gap-y-2 border-b px-4 py-3 ${
        isError
          ? 'border-red-300 bg-red-50 text-red-900'
          : 'border-amber-300 bg-amber-50 text-amber-950'
      }`}
    >
      <AlertTriangle className="h-5 w-5 shrink-0" aria-hidden="true" />
      <div className="min-w-[min(100%,18rem)] flex-1">
        <p className="font-bold">
          {isConflict ? '学习数据已在其他页面更新' : isError ? '学习数据保存失败' : '本地存储提醒'}
        </p>
        <p className="mt-0.5 text-sm leading-5">{snapshot.message}</p>
      </div>
      {isConflict && snapshot.recovery ? (
        <button
          type="button"
          className="ml-8 inline-flex min-h-10 items-center gap-2 rounded-md border border-amber-500 bg-white px-3 py-2 text-sm font-bold text-amber-950 shadow-sm transition hover:bg-amber-100 sm:ml-0"
          onClick={snapshot.recovery.run}
        >
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
          {snapshot.recovery.label}
        </button>
      ) : (
        <button
          type="button"
          aria-label="关闭存储提示"
          className="rounded-md p-2 transition hover:bg-black/5"
          onClick={() => storageHealth.clear()}
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    </div>
  )
}
